module.exports = __webpack_public_path__ + "img/1-07.72f9b418.png";